export default __webpack_public_path__ + "static/media/Tony's General Store - Split City.13192b2d.png";